import React from "react";
import {connect} from "react-redux";
import {replace} from "react-router-redux";
import {Col, Form, FormGroup, FormControl, ControlLabel, Button, Radio} from "react-bootstrap";
import {getUrlParams, removePath} from "../../common/utils";
import {initEBT} from "../../actions/pay/paymentActions";
import {isFetching} from "../../actions/common/fetchingActions";
import {clearHiddenUrlParams} from "../../actions/common/commonActions";
import {formatMoney} from "../../common/basket";
import {URLs, FetchingTypes} from "../../common/constants";
import ModalPopup from "../../components/common/ModalPopup";
import styles from "../../css/paymentDetailsForm.less"

class EBTForm extends React.Component {
    constructor(props, context) {
        super(props, context);
        const params = getUrlParams();
        this.state = {
            firstName: props.memberDetails.firstName || params.firstName,
            lastName: props.memberDetails.lastName || params.lastName,
            cardNumber: '',
            isValidFirstName: true,
            isValidLastName: true,
            isValidCardNumber: true,
            partialAmountValidationMessage: null,
            dismissErrorMessage: false,
            fullAmount: true,
            partialAmount: '',
        };
    }

    checkName = () => {
        let reg = /^[A-Za-z ]+$/;
        let resFirstName = this.state.firstName && reg.test(this.state.firstName);
        let resLastName = this.state.lastName && reg.test(this.state.lastName);
        this.setState({"isValidFirstName": resFirstName});
        this.setState({"isValidLastName": resLastName});
        return resFirstName && resLastName;
    };

    checkCardNumber = () => {
        let reg = /^[0-9]{16}$|^[0-9]{19}$/;
        let res = reg.test(this.state.cardNumber);
        this.setState({"isValidCardNumber": res});
        return res;
    };

    checkPartialAmount = () => {
        if (this.state.fullAmount) {
            this.setState({"partialAmountValidationMessage": null});
            return true;
        }
        const partialAmount = parseFloat(this.state.partialAmount)
        if (isNaN(partialAmount)) {
            this.setState({"partialAmountValidationMessage": 'Please enter an amount'});
            return false;
        }
        if (partialAmount > this.props.total){
            this.setState({"partialAmountValidationMessage": 'Please enter an amount smaller than $' + this.props.total});
            return false;
        }
        return true;
    }

    isValidForm = () => {
        let res1 = this.checkName();
        let res2 = this.checkCardNumber();
        let res3 = this.checkPartialAmount();
        return  res1 && res2 && res3;
    };

    onSubmitClick = () => {
        if (this.isValidForm()) {
            let ebtInfo = {
                farmKey: this.props.serverStaticData.farmKey,
                memberKey: this.props.memberDetails.key,
                subscriptionKey: this.props.subscriptionKey,
                postActionKey: this.props.postActionKey,
                cardNumber: this.state.cardNumber,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                amount: this.state.fullAmount ? this.props.total : Number(this.state.partialAmount),
                totalAmount: this.props.total + this.props.feeAmount,
            };
            this.props.initEBT(ebtInfo, this.props.pageContext);
        }
    };

    onCheckBalanceClick = () => {
        if (this.isValidForm()) {
            let ebtInfo = {
                farmKey: this.props.serverStaticData.farmKey,
                memberKey: this.props.memberDetails.key,
                subscriptionKey: this.props.subscriptionKey,
                postActionKey: this.props.postActionKey,
                cardNumber: this.state.cardNumber,
                firstName: this.state.firstName,
                lastName: this.state.lastName,
                amount: 0,
            };
            this.props.initEBT(ebtInfo, 'BALANCE');
        }
    };

    onBackClick = () => {
        //workaround for back
        document.getElementById('cardNumber').value = '';
        this.props.onBackClick();
    };

    updateValueToState = (event) => {
        let newState = {};
        newState[event.target.id] = event.target.value;
        this.setState(newState);
    };

    handleAmountSelectorChange = (event) => {
        if (event.target.value === 'on') {
            this.setState({fullAmount: event.target.id === 'amountFullSelection'});
        }
    };

    handlePartialAmountChange = (event) => {
        let amount = event.target.value;
        if(!(/^\d+(?:[.]\d*?)?$/).test(amount) && amount !== "") {
            return;
        }
        if (amount === '0') {
            amount = '';
        }
        this.setState({partialAmount: amount});
    };

    isError = () => {
        return this.props.errorMessage && !this.state.dismissErrorMessage;
    }

    showErrorMessage = () => {
        const buttonText = "Close";
        const errorMessage = decodeURIComponent(this.props.errorMessage).replace(/\+/g,  ' ');
        return (
            <ModalPopup
                message={errorMessage}
                middle={{text:buttonText, callback:()=> this.setState({dismissErrorMessage: true})}}/>
        );
    }

    render() {
        let submitLoadingClass = this.props.showLoading? " loading" : "";
        const submitClasses = "submit-order button" +  submitLoadingClass;
        return (
            <div className="form _lr-hide">
                <div className="title">
                    <i className="back-sign-in-arrow hidden-sm hidden-md hidden-lg" onClick={this.onBackClick} disabled={this.props.showLoading}/>
                    <h1>EBT Online</h1>
                    <div className="buttons">
                        <Button bsStyle="primary" className="back button hidden-xs" onClick={this.onBackClick} disabled={this.props.showLoading}>Back</Button>
                        <Button bsStyle="primary" className={submitClasses + " hidden-xs"} onClick={this.onSubmitClick} disabled={this.props.showLoading || this.isError()}>Submit</Button>
                    </div>
                </div>
                {this.isError() && this.showErrorMessage()}
                <div>
                <h5>Please enter your EBT card number you use for this payment. Then you will be redirected to Fiserv PIN pad to enter your PIN.</h5>
                <div className="border-container">
                    <div className="inner-container">
                        <fieldset disabled={this.props.showLoading} className="form-container container-fluid">
                            <div className="inner-form">
                                <Form horizontal>
                                    <FormGroup validationState={!this.state.isValidFirstName ? "error" : null}>
                                        <Col sm={3}>First Name</Col>
                                        <Col sm={3}><FormControl id="firstName" type="text" placeholder="First Name" onChange={this.updateValueToState} value={this.state.firstName}/></Col>
                                        { !this.state.isValidFirstName ?
                                            <Col sm={6}><ControlLabel>Please enter a valid name (Only alphabetic)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={!this.state.isValidLastName? "error" : null}>
                                        <Col sm={3}>Last Name</Col>
                                        <Col sm={3}><FormControl id="lastName" type="text" placeholder="Last Name" onChange={this.updateValueToState} value={this.state.lastName}/></Col>
                                        { !this.state.isValidLastName ?
                                            <Col sm={6}><ControlLabel>Please enter a valid last name (Only alphabetic)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={!this.state.isValidCardNumber ? "error" : null}>
                                        <Col sm={3}>Card Number</Col>
                                        <Col sm={3} className="card-number">
                                            <FormControl id="cardNumber" type="text" onChange={this.updateValueToState} className="_lr-hide"/>
                                        </Col>
                                        <Col sm={2}><Button bsStyle="primary" className="submit-order button" onClick={this.onCheckBalanceClick}>Check Balance</Button></Col>
                                        { !this.state.isValidCardNumber ?
                                            <Col sm={4}><ControlLabel>Please enter a valid EBT card number (16 or 19 digits)</ControlLabel></Col> : undefined
                                        }
                                    </FormGroup>
                                    <FormGroup validationState={this.state.partialAmountValidationMessage ? "error" : null}>
                                        <Col sm={3}>Amount to pay</Col>
                                        <Col sm={9}>
                                            <Radio name="amountFullSelection" id="amountFullSelection" checked={this.state.fullAmount} onChange={this.handlePartialAmountChange} className="amount-full-radio">
                                                <div>
                                                    <div className="payment-amount-description">Pay full amount of {formatMoney(this.props.total)} using SNAP EBT</div>
                                                </div>
                                            </Radio>
                                            <Radio name="amountPartialSelection" id="amountPartialSelection" checked={!this.state.fullAmount} onChange={this.handleAmountSelectorChange} className="amount-partial-radio">
                                                <div className="amount-partial-div">
                                                    <Col md={4} xs={7}><div className="payment-amount-description amount-partial-text">Pay only partial amount using SNAP EBT</div></Col>
                                                    <Col md={2} xs={5}> <input id="partialAmount" type="text" className="payment-amount-input amount-partial-input" disabled={this.state.fullAmount}
                                                           placeholder="Enter Amount" onChange={this.handlePartialAmountChange}  value={this.state.partialAmount}/></Col>
                                                    { this.state.partialAmountValidationMessage &&
                                                        <Col md={6} xs={12}><ControlLabel className="amount-partial-error">{this.state.partialAmountValidationMessage}</ControlLabel></Col>
                                                    }
                                                </div>
                                            </Radio>
                                            <div className="payment-amount-description amount-partial-note">You must pay the remainder of the order by contacting {this.props.serverStaticData.farmName} or from your member account. Please be advised that only fully paid orders will be processed.</div>
                                        </Col>
                                    </FormGroup>
                                </Form>
                            </div>
                        </fieldset>
                        <div className="bottom-container">
                            <Button  bsStyle="primary" className={submitClasses + " visible-xs"} onClick={this.onSubmitClick} disabled={this.props.showLoading}>Submit</Button>
                        </div>
                    </div>
                </div>
                </div>
            </div>);
    }
}

const mapStateToProps = (state, ownProps) => {
    let checkout = state.checkout || {};
    let returnObject = {
        showLoading: isFetching(state, FetchingTypes.SUBMIT),
        serverStaticData: state.staticData,
        subscriptionKey: state.summary.key,
        orderKey: state.orderStatus.orderKey,
        postActionKey: checkout.postActionKey,
        memberDetails: (state.memberDetails || {}),
        errorMessage: (state.staticData.params || {}).error
    };
    if(ownProps.pageContext === URLs.JOIN || ownProps.pageContext === URLs.STORE) {
        let summary = state.summary;
        let customAmount = summary.customAmount.split("|");
        returnObject.total = parseFloat(customAmount[0]);
        returnObject.feeAmount = customAmount.length > 1 ? parseFloat(customAmount[1]) : 0;
    } else if(ownProps.pageContext === URLs.PAY) {
        returnObject.total = (ownProps.totalToPay && ownProps.totalToPay > 0) ? ownProps.totalToPay : ownProps.amount;
    }else {
        returnObject.total = (state.orderStatus.totals.editableTotal || {}).fullPrice;
    }
    return returnObject;
};

const mapDispatchToProps = (dispatch) => {
    return {
        initEBT: (ebtInfo, pageContext) => {
            dispatch(clearHiddenUrlParams());
            dispatch(initEBT(ebtInfo, pageContext));
        },
        onBackClick: () => {
            dispatch(clearHiddenUrlParams());
            dispatch(replace(removePath('/ebt')));
        }
    }
};
export default connect(mapStateToProps, mapDispatchToProps)(EBTForm);


// WEBPACK FOOTER //
// ./src/containers/pay/EBTForm.js